import usersService from '../../services/usersService'
import activitiesService from '../../services/activitiesService'

class UsersController {
  createUser = usersService.createUser
  fetchUserDetails = usersService.fetchUserDetails
  searchUsers = usersService.searchUsers
  updateUser = usersService.updateUser
  toggleDeactivateUser = usersService.toggleDeactivateUser
  fetchFollowing = usersService.fetchFollowing
  fetchLatestCustomerActivities = activitiesService.fetchLatestCustomerActivities
  setCurrentOrder = usersService.setCurrentOrder
  getCurrentOrder = usersService.getCurrentOrder
  fetchPersonalNotifications = usersService.fetchPersonalNotifications
  setNotificationUserStatus = usersService.setNotificationUserStatus
  getTotalNotificationsNotViewed = usersService.getTotalNotificationsNotViewed
  fetchCustomerRelationshipsForUser = usersService.fetchCustomerRelationshipsForUser
  setCustomerRelationshipsForUser = usersService.setCustomerRelationshipsForUser
  setStoreRelationshipsForUser = usersService.setStoreRelationshipsForUser
  setDepartmentRelationshipsForUser = usersService.setDepartmentRelationshipsForUser
}

export default new UsersController() 


// WEBPACK FOOTER //
// ../src/controllers/usersController/usersController.js